"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _core = _interopRequireDefault(require("./core"));
var _logger = _interopRequireDefault(require("../logger"));
var _uuid = require("uuid");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Display = exports["default"] = /*#__PURE__*/function (_Core) {
  function Display(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, Display);
    _this = _callSuper(this, Display, [props]);
    _this.connection = props.connection;
    _this.on = _this.on.bind(_this);
    _this.appName = props.appName;
    _this._events = {};
    _this.ready = false;
    _this.init();
    _this.myServices = ["ddm"];
    return _this;
  }
  (0, _inherits2["default"])(Display, _Core);
  return (0, _createClass2["default"])(Display, [{
    key: "handleMessage",
    value: function () {
      var _handleMessage = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(message) {
        var data, parsedData, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(message.origin === 'sdk-' + this.appName)) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return");
            case 1:
              if (this.ready === false) {
                this.ready = true;
                this.trigger("ready", true);
                _logger["default"].success("Initialization done", "Module is now ready!", "Display");
              }
              _t = message.action;
              _context.next = _t === 'System.SDK.ServiceNotification.Response' ? 2 : _t === 'System.DisplayManager.ApplicationHeartbeat' ? 4 : _t === 'System.DisplayManager.ApplicationHeartbeat.Response' ? 5 : _t === 'System.ServiceNotification' ? 6 : _t === "System.AppMessage.data" ? 9 : 10;
              break;
            case 2:
              if (!(this.myServices.indexOf(message.origin) === -1)) {
                _context.next = 3;
                break;
              }
              return _context.abrupt("return");
            case 3:
              // Store this service into this.services
              this.services[message.origin] = JSON.parse(message.data);
              _logger["default"].success("ServiceNotification", "New service added", message.origin);
              return _context.abrupt("return");
            case 4:
              this.trigger("appHeartbeat", message.data);
            case 5:
              this.trigger("appHeartbeatResponse", message.data);
            case 6:
              if (!(this.myServices.indexOf(message.origin) === -1)) {
                _context.next = 7;
                break;
              }
              return _context.abrupt("return");
            case 7:
              // Send our data
              data = JSON.parse(message.data);
              _context.next = 8;
              return this.connection.invoke('messaging', {
                uuid: (0, _uuid.v4)(),
                action: "".concat(data.serviceIdentification, ".ServiceNotification.Response"),
                requestUuid: "",
                timestamp: Number(BigInt(Date.now()) * 1000000n),
                origin: "sdk-" + this.appName,
                data: JSON.stringify({
                  serviceIdentification: "System.SDK",
                  serviceAbbreviation: "sdk-" + this.appName,
                  publicKey: this.publicKey
                })
              });
            case 8:
              // Store this service into this.services
              this.services[message.origin] = JSON.parse(message.data);
              _logger["default"].success("ServiceNotification", "New service added", message.origin);
              this.ready = true;
              this.trigger("ready", true);
              return _context.abrupt("return");
            case 9:
              try {
                parsedData = JSON.parse(message.data);
                this.trigger("receive_message", parsedData);
              } catch (error) {
                console.error("Error parsing nested content:", error);
              }
              return _context.abrupt("return");
            case 10:
              return _context.abrupt("continue", 11);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function handleMessage(_x) {
        return _handleMessage.apply(this, arguments);
      }
      return handleMessage;
    }()
  }, {
    key: "appMessageForward",
    value: function appMessageForward(sendData) {
      var payload = {
        action: "System.AppMessage.data",
        uuid: (0, _uuid.v4)(),
        origin: "sdk-" + this.appName,
        // Top-level origin for general reference
        request_uuid: "",
        timestamp: Number(BigInt(Date.now()) * 1000000n),
        data: JSON.stringify({
          // Nested origin if needed for specific handling
          data: sendData,
          app_name: "sdk-" + this.appName // Using 'content' to store actual data
        })
      };
      this.connection.invoke("messaging", payload)["catch"](function (error) {
        console.error("Error sending data:", error);
      });
    }
  }, {
    key: "detectServices",
    value: function detectServices() {
      var _this2 = this;
      var found = false;
      Object.keys(this.services).forEach(function (key) {
        if (_this2.myServices.includes(key)) {
          found = true;
        }
      });
      return found;
    }
  }, {
    key: "getScreen",
    value: function getScreen() {
      var _this3 = this;
      return new Promise(function (resolve) {
        var uuid = (0, _uuid.v4)();
        _this3.connection.invoke("messaging", JSON.stringify({
          uuid: uuid,
          requestUuid: "",
          timestamp: Number(BigInt(Date.now()) * 1000000n),
          origin: "sdk-" + _this3.appName,
          action: 'System.DisplayManager.GetScreen'
        }));
        _this3.connection.on("messaging", function (data) {
          if (data['requestUuid'] === uuid) {
            resolve(data);
          }
        });
      });
    }
  }, {
    key: "BringAppToFront",
    value: function BringAppToFront(app_id) {
      var _this4 = this;
      return new Promise(function (resolve) {
        var uuid = (0, _uuid.v4)();
        _this4.connection.invoke('messaging', JSON.stringify({
          uuid: uuid,
          requestUuid: "",
          origin: 'sdk-' + _this4.appName,
          timestamp: Number(BigInt(Date.now()) * 1000000n),
          action: 'System.DisplayManager.BringAppToFront',
          data: JSON.stringify({
            cpvuuid: app_id
          })
        }));
        _this4.connection.on("messaging", function (msg) {
          if (msg.action === "System.DisplayManager.BringAppToFront.Response" && msg.requestUuid === uuid) {
            resolve(msg.data);
          }
        });
      });
    }
  }, {
    key: "getApplication",
    value: function getApplication(app_run_uuid) {
      var _this5 = this;
      return new Promise(function (resolve) {
        var uuid = (0, _uuid.v4)();
        _this5.connection.invoke("messaging", JSON.stringify({
          uuid: uuid,
          requestUuid: "",
          origin: 'sdk-' + _this5.appName,
          timestamp: Number(BigInt(Date.now()) * 1000000n),
          action: 'System.DisplayManager.ApplicationConfig',
          data: JSON.stringify({
            app_run_uuid: app_run_uuid
          })
        }));
        _this5.connection.on("messaging", function (msg) {
          if (msg.action === "System.DisplayManager.ApplicationConfig.Response" && msg.requestUuid === uuid) {
            var jsonString = msg.data;
            var jsonObject = JSON.parse(jsonString);
            var formattedJsonString = JSON.stringify(jsonObject, null, 2);
            resolve(formattedJsonString);
          }
        });
      });
    }
  }, {
    key: "getListRunningApplications",
    value: function getListRunningApplications() {
      var _this6 = this;
      return new Promise(function (resolve) {
        var uuid = (0, _uuid.v4)();
        _this6.connection.invoke("messaging", JSON.stringify({
          uuid: uuid,
          requestUuid: "",
          origin: 'sdk-' + _this6.appName,
          timestamp: Number(BigInt(Date.now()) * 1000000n),
          action: 'System.DisplayManager.GetListOfRunningApps',
          data: JSON.stringify({
            data: {}
          })
        }));
        _this6.connection.on("messaging", function (msg) {
          if (msg.action === "System.DisplayManager.GetListOfRunningApps.Response" && msg.requestUuid === uuid) {
            var jsonString = msg.data;
            var jsonObject = JSON.parse(jsonString);
            var formattedJsonString = JSON.stringify(jsonObject, null, 2);
            resolve(formattedJsonString);
          }
        });
      });
    }
  }, {
    key: "sendAppHeartbeatInterval",
    value: function sendAppHeartbeatInterval(appRunUuid) {
      var _this7 = this;
      return new Promise(function (resolve, reject) {
        var uuid = (0, _uuid.v4)(); // Make sure 'v4' is imported from 'uuid'
        var action = "System.DisplayManager.ApplicationHeartbeat"; // Assuming action is static here as in your example
        // Construct the payload
        var payload = {
          uuid: uuid,
          requestUuid: "",
          // Assuming this should be left empty as in the Python code
          action: action,
          timestamp: Number(BigInt(Date.now()) * 1000000n),
          data: JSON.stringify({
            app_run_uuid: appRunUuid,
            // Ensure the key names match server expectations
            timeout: 20
          }),
          origin: "sdk-" + _this7.appName // Changed from "ddm" to "sdk" as per your JavaScript function
        };
        // Invoke the messaging system
        _this7.connection.invoke("messaging", payload)["catch"](reject); // Add basic error handling
        // Listen for response
        _this7.connection.on("messaging", function (msg) {
          try {
            if (msg.action === "System.DisplayManager.ApplicationHeartbeat.Response") {
              var jsonObject = JSON.parse(msg.data);
              var formattedJsonString = JSON.stringify(jsonObject, null, 2);
              resolve(formattedJsonString);
            }
          } catch (error) {
            reject(error);
          }
        });
      });
    }
  }, {
    key: "init",
    value: function init() {
      _logger["default"].info("Initialization", "Module initialization started, detecting services", "Display");
      var foundServices = this.detectServices();
      if (!foundServices) {
        _logger["default"].warn("Initialization", "No services found. In most cases, this is okay, services will show up soon.", "Display");
      } else {
        this.ready = true;
        this.trigger("ready", true);
        this.connection.on("messaging", this.handleMessage.bind(this));
      }
      this.connection.on("messaging", this.handleMessage.bind(this));
    }
  }]);
}(_core["default"]);